module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Bare Chronicle of Existence")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#richard-arnold-clarke-but-procrastination-and-delay-are-my-only-portion-in-this-world."
    }
  }, [_vm._v("Richard Arnold Clarke – “But Procrastination and Delay Are My Only Portion in this World.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#start-of-ww1"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#hms-india-she-is-a-good-sea-boat."
    }
  }, [_vm._v("HMS India – “She is a Good Sea Boat.”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#sinking-of-hms-india-submarine-on-starboard-bow"
    }
  }, [_vm._v("Sinking of HMS India— “Submarine on Starboard Bow”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#what-to-do-with-the-sunken-sailors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What to Do with the Sunken Sailors?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-first-few-months-well-news-is-scarce.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Few Months— “Well, News is Scarce.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#what-about-the-rest-of-the-crew",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#first-half-of-1916-hopes-ambitions-and-ideals-have-gone.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Half of 1916 – “Hopes, Ambitions and Ideals have Gone.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#what-was-happening-in-the-camp",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#what-were-the-family-doing-1",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#second-half-of-1916-not-letters-but-a-bare-chronicle-of-existence.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Half of 1916 – “Not Letters but a Bare Chronicle of Existence.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#what-was-happening-in-the-camp-1",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#first-half-of-1917-the-news-is-forced.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Half of 1917 – “The News Is Forced.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#what-was-happening-in-the-camp-2",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#what-were-the-family-doing-2",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#second-half-of-1917-i-regret-my-letters-often-get-left-unwritten-nowadays.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Half of 1917 – “I Regret My Letters Often Get Left Unwritten Nowadays.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#what-was-happening-in-the-camp-3",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#what-were-the-family-up-doing",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#first-half-of-1918-london-seems-a-long-way-off.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Half of 1918 – “London Seems a Long Way Off.”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#second-half-of-1918-i-am-in-no-wise-over-brimming-with-cheerfulness.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Half of 1918 — “I Am in No Wise over Brimming with Cheerfulness.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#what-was-the-family-doing",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#a-caricaturists-view-a-great-humourist-has-obviously-not-let-this-opportunity-go.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Caricaturist’s View – “A Great Humourist Has Obviously Not Let this Opportunity Go.”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#what-next-what-are-the-stories-of-and-what-happened-to-some-of-the-hms-india-crew",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Next? What Are the Stories of and What Happened to some of the HMS India Crew?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#rogues-gallery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rogues Gallery")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#the-rest-of-arnolds-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rest of Arnold’s Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-clarke-family",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clarke Family")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#hms-india-casualties",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hms India Casualties")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#hms-india-gotaland-survivors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HMS India Gotaland Survivors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#hms-india-surviving-interned-crew",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HMS India Surviving Interned Crew")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0